import { message } from 'antd';
import axios from 'axios';
import { getGuestId } from '../Service/guest';
// 接口地址按环境自动切：npm run dev 走本地后端，npm run build 走线上，不用手动改来改去。
// 临时想指到别的地址（内网穿透、测试环境）时，在 .env.local 里设 REACT_APP_API_BASE=https://xxx/ 即可，不要改这里。
const DEV_BASE = 'http://localhost:9992/';
const PROD_BASE = 'https://lingganfengbao.com/';
const withSlash = (url) => (url.endsWith('/') ? url : `${url}/`);
const envBase = (process.env.REACT_APP_API_BASE || '').trim();
export const baseURL = envBase ? withSlash(envBase) : process.env.NODE_ENV === 'production' ? PROD_BASE : DEV_BASE;
// 只给新版写作 / PPT 接口带设备标识，避免老接口因跨域预检多出自定义头
const GUEST_SCOPED = /^\/?(ai\/outline|ai\/order|ai\/pptgen)\//;
axios.interceptors.request.use((config) => {
    if (GUEST_SCOPED.test(config.url || '')) {
        config.headers = config.headers || {};
        if (!config.headers['X-Guest-Id']) config.headers['X-Guest-Id'] = getGuestId();
    }
    return config;
});
axios.defaults.baseURL = baseURL;

axios.interceptors.response.use(
    (response) => {
        return response.data || response;
    },
    (error) => {
        // 如果是请求被取消，静默处理，不显示错误消息
        if (
            error.name === 'AbortError' ||
            error.name === 'CanceledError' ||
            error.code === 'ERR_CANCELED' ||
            error.message?.includes('canceled')
        ) {
            throw error;
        }

        if (!error.config.slient) {
            // 网络断开 / 接口无响应时没有 msg，不弹只有红叉没有文字的空提示
            const msg = error.response && error.response.data && error.response.data.msg;
            message.error(msg || '网络异常，请稍后重试');
        }

        // if (error.config.checkAuth && error.response.status === 424) {
        //   loginInstance.open();
        // }
        throw error;
    },
);

export const get = (url, data, config = {}) => {
    const params = data || {};
    const { headers = {} } = config;
    config.headers = {
        ...headers,
    };

    return axios.get(url, {
        ...config,
        params: params,
    });
};

export const post = (url, data = {}, config = {}) => {
    let postData = data || {};
    const { headers = {} } = config;
    config.headers = {
        ...headers,
    };

    return axios.post(url, postData, config);
};

export default axios;
